/**
 * Import Dependency
 */
import { handleActions } from 'redux-actions'

/**
 * Export
 */
export const packages = handleActions({
  UPDATE_PACKAGES: (state, action) => {
    return action.payload
  },
}, null)

export default {
  packages,
}



// WEBPACK FOOTER //
// ./src/reducers/components/packages.js